<template>
  <div class="media" @click="initial ? act() : startTimer()" :class="textColor">
    <b-icon
      :icon="icon"
      size="is-small"
      class="media-left"
      :class="icon === 'loader' && 'spin'"
    ></b-icon>
    <span>{{ placingText }}</span>
  </div>
</template>

<script>
import { bus } from "@/components/spaces/bus.js";

export default {
  props: ["focused", "placing"],
  data() {
    return {
      initial: false,
      existingTimeout: undefined,
    };
  },
  methods: {
    act() {
      this.initial = false;
      bus.$emit("placing-event", this.$attrs.space.id);
    },
    startTimer() {
      this.initial = true;
      this.existingTimeout = setTimeout(() => {
        this.initial = false;
      }, 5000);
    },
  },
  watch: {
    focused(dropdownOpen) {
      if (!dropdownOpen) this.initial = dropdownOpen;
    },
    initial(newValue) {
      if (!newValue) clearTimeout(this.existingTimeout);
    },
  },
  computed: {
    icon() {
      if (this.initial) return "alert-circle";
      else if (this.placing === this.$attrs.space.id) return "loader";
      else return "plus";
    },
    placingText() {
      if (this.initial) return "Click to confirm";
      else if (this.placing === this.$attrs.space.id) return "Adding...";
      else return this.$attrs.space.title;
    },
    textColor() {
      const placing = this.placing === this.$attrs.space.id;
      return (this.initial || placing) && "has-text-success";
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/bulma_overrides.scss";

.media {
  font-weight: 400;
}
</style>
